<template>
    <section id="description" class="scroll-mt-24 space-y-6">
        <div class="text-lg font-semibold">{{ $t('Description') }}</div>

        <div class="space-y-2 prose-item-sm" v-if="item.description">
            <div class="text-sm font-bold text-primary">
                {{ $t('Product description') }}
            </div>
            <div v-html="item.description"></div>
        </div>

        <div class="space-y-2 prose-item-sm" v-if="item.property?.description">
            <div class="text-sm font-bold text-primary">
                {{ $t('Property description') }}
            </div>

            <div
                :class="{
                    'line-clamp-3 overflow-hidden': !showFullPropertyDescription
                }"
                v-html="item.property.description"
            ></div>

            <button v-if="!showFullPropertyDescription" type="button" class="text-sm font-medium text-primary hover:underline" @click="showFullPropertyDescription = true">
                {{ $t('Read more') }}
            </button>
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
    item: {
        type: Object,
        required: true
    }
})

const showFullPropertyDescription = ref(false)
</script>
